/**
 * Auth localStorage utilities.
 * All auth state that must survive page refresh lives here.
 * Keys are prefixed to avoid clashes on shared origins.
 */

const PREFIX = 'crmsuite';

const KEYS = {
  token:        `${PREFIX}_token`,
  refreshToken: `${PREFIX}_refresh_token`,
  user:         `${PREFIX}_user`,
  session:      `${PREFIX}_session`,
};

export const getAuthToken    = ()        => localStorage.getItem(KEYS.token);
export const getRefreshToken = ()        => localStorage.getItem(KEYS.refreshToken);
export const getStoredUser   = ()        => JSON.parse(localStorage.getItem(KEYS.user)    || 'null');
export const getStoredSession= ()        => JSON.parse(localStorage.getItem(KEYS.session) || 'null');
export const isAuthenticated = ()        => !!getAuthToken();

export const saveAuthSession = (auth, user, session) => {
  localStorage.setItem(KEYS.token,        auth.access_token);
  localStorage.setItem(KEYS.refreshToken, auth.refresh_token);
  localStorage.setItem(KEYS.user,         JSON.stringify(user));
  localStorage.setItem(KEYS.session,      JSON.stringify(session));
};

export const clearAuthSession = () => {
  Object.values(KEYS).forEach((k) => localStorage.removeItem(k));
};

export const getUserScopeIds = (user = null) => {
  const u = user ?? getStoredUser();
  return Array.isArray(u?.scopes) ? u.scopes : [];
};

export const hasAnyScope = (requiredScopes, user = null) => {
  const scopes = getUserScopeIds(user);
  return requiredScopes.some((s) => scopes.includes(s));
};
